import NavBar from '@/components/Nav.vue';

export default {
    name: 'CardPage',
    components: {
        NavBar,
    },
}